// extracted by mini-css-extract-plugin
export default {"container":"skills_container__eAGXJ","mainStack":"skills_mainStack__SHyu5","legend":"skills_legend__kFZek","title":"skills_title__tueF2"};